import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Link } from 'react-router-dom';
import M from 'materialize-css/dist/js/materialize.min.js'
import Modal from '../../../helper/modal';
import TableHeader from '../../../helper/tableHeader';
import $ from 'jquery';
import {unlockCollateral} from '../../../../actions/orderbook/set';
import {payNEO,payBTC,payETH,payLSK,payWAV,payNRG,payEMB,payDAI,payUSDT} from '../../../../actions/transfers/set';
import {colors} from '../../../../config'
import './matched.css';
import TransferDetails from '../../../helper/transferDetails';
import {getNEOFee,getBTCFee,getETHFee,getLSKFee,getWAVFee,getNRGFee,getEMBFee,getDAIFee,getUSDTFee} from '../../../../actions/transfers/fees';
import {take} from 'ramda';

const {green,red} = colors;

class MatchedOrders extends Component {
  constructor(){
    super();
    this.state = {from:0,amount:0,to:0,name:"BTC",rawTx:null,chain:'',txHash:null,txOutputIndex:0,view:'complete'};
  }
  renderModal(){
    let component = (<TransferDetails settle={true} amount={this.state.amount} to={this.state.to} from={this.state.from} fee={this.props.fee} chain={this.state.chain} />)
    return (
      <Modal id='modalSettlement' noClose={true} classes='modal modalOrders black-text' chain={this.state.chain} component={component} isOrder={false}  decryption={true} buttonText={"Confirm"} passwordId='settlepass' buttonAction={this.submitOperation.bind(this)} />
    )
  }
  renderUnlock(){
    return (
      <Modal id='modalUnlock' noClose={true} classes='modal modalOrders black-text' title='Unlock Confirmation' decryption={true} buttonText={"Confirm"} passwordId='unlockpass' buttonAction={this.submitOperationUnlock.bind(this)} />
    )
  }
  submitOperation(){
    let password = $("#settlepass").val();
    let {amount,to,chain} = this.state;
    this.props[`pay${chain.toUpperCase()}`]({password,amount,to},(err,tx)=>{
      if(!err) {
        var instance = M.Modal.getInstance(document.querySelectorAll('#modalSettlement')[0]);
        if(instance) instance.close();
        $("#settlepass")[0].value = '';
        M.toast({html: 'Transaction Submitted!',classes: "green",displayLength:2000});
      }
      else {
        M.toast({html: err,classes:"red",displayLength:2000});
      }
    })
  }
  submitOperationUnlock(){
    let password = $("#unlockpass").val();
    this.props.unlockCollateral({password,txHash:this.state.txHash,txOutputIndex:this.state.txOutputIndex},(err,tx)=>{
      if(!err) {
        var instance = M.Modal.getInstance(document.querySelectorAll('#modalUnlock')[0]);
        if(instance) instance.close();
        $("#unlockpass")[0].value = '';
        M.toast({html: 'Transaction Submitted!',classes: "green",displayLength:2000});
      }
      else {
        M.toast({html: err,classes:"red",displayLength:2000});
      }
    })
  }
  handleFormSubmit({from,to,amount,chain}) {
    this.setState({from,to,amount,chain});
    this.props[`get${chain.toUpperCase()}Fee`](amount);
    var instance = M.Modal.getInstance(document.querySelectorAll('#modalSettlement')[0]);
    if(instance) instance.open();
    setTimeout(()=>{
      if($("#settlepass")) $("#settlepass").focus()
    },100)
  }
  handleFormSubmitUnlock({txHash,txOutputIndex}) {
    this.setState({txHash,txOutputIndex});
    var instance = M.Modal.getInstance(document.querySelectorAll('#modalUnlock')[0]);
    if(instance) instance.open();
    setTimeout(()=>{
      if($("#unlockpass")) $("#unlockpass").focus()
    },100)
  }
  renderItems(orders,past){
    let ordersToFulfill = {};
    return orders.map(({
      unlocked,sendsToAddress, receivesFromAddress, sendsFromChain,receivesToChain, sendsAmount,receivesAmount, sendsFromAddress,
      receivesToAddress, yourStatus,theirStatus,collateral,deadline,txHash,txOutputIndex
    }) => {

      let them = (<a style={{color:theirStatus ? green : red}}>{theirStatus ? `Received ${receivesToChain.toUpperCase()}` : `Waiting for ${receivesToChain.toUpperCase()}`} </a>)
      let sendClick = this.handleFormSubmit.bind(this,{from:sendsFromAddress,to:sendsToAddress,amount:sendsAmount,chain:sendsFromChain})
      let unlockClick = this.handleFormSubmitUnlock.bind(this,{txHash,txOutputIndex})

      //user has the proper wallet
      let properWallet = this.props.wallet[sendsFromChain.toLowerCase()] && sendsFromAddress.toLowerCase() == this.props.wallet[sendsFromChain.toLowerCase()].address.toLowerCase();

      let you = yourStatus == true ?
        (<a style={{color:green}}>{`Sent ${sendsFromChain.toUpperCase()}`} </a>)
        :
        (<a style={{color:'rgb(106, 161, 255)',cursor:'pointer'}} onClick={sendClick}><u>Send {`${sendsFromChain.toUpperCase()}`}</u> <i className='material-icons sendIcon'>send</i> </a>)

      if(!properWallet) you = <Link to='/' style={{color:'white',cursor:'pointer'}} ><u> Upload Wallet</u> </Link>

      // if(yourStatus === false )
      //Analyze Txhash and output index for those txs that are being sent
      if(ordersToFulfill[`${sendsFromChain}${sendsFromAddress}${sendsToAddress}${sendsAmount}`]){
        you = (<a style={{color:'grey'}}>Wait to Send </a>)
      }

      if(sendsFromChain === 'NRG') you = null;
      if(receivesToChain === 'NRG') them = null;

      if(past){
        them = ''
        deadline = 'Settled';
        you = (<a style={{color:red}} >Asset Never Sent</a>)
        if(sendsFromChain === 'NRG' && !yourStatus) you = (<a style={{color:'grey'}} >{receivesToChain} Received</a>)
        if(unlocked && yourStatus) you = (<a style={{color:'grey'}} >Unlocked</a>)
        else if(yourStatus || (!yourStatus && !theirStatus)) you = (<a style={{color:green,cursor:'pointer'}} onClick={unlockClick}><u>Unlock Collateral</u></a>)
      }

      if(!past && (yourStatus== false || yourStatus == 'Sending')) ordersToFulfill[`${sendsFromChain}${sendsFromAddress}${sendsToAddress}${sendsAmount}`] = `${txHash}${txOutputIndex}`;

      return (
        <tr className='matched'>
          <td className='matchedSend'> {`${sendsAmount}`} {sendsFromChain} to <br/> {`${sendsToAddress}`}</td>
          <td className='matchedReceive'> {`${receivesAmount}`} {receivesToChain} to <br/> {`${receivesToAddress}`}</td>
          <td className='matchedCollateral'> {collateral} </td>
          <td className='matchedDeadline'> {deadline} </td>
          <td className='matchedStatus'> {you} {them} </td>
        </tr>
      );
    });
  }
  changeView(view){
    this.setState({view})
  }
  render() {
    let items = ['Send','Receive','Collateral','Settlement','Status']
    let classes = ['matchedSend','matchedReceive','matchedCollateral','matchedDeadline','matchedStatus'];
    let titleStyle = {marginTop:'10px', marginLeft:'2px',color:'white'}
    let completeColor = this.props.view == 'complete' ? 'white' : 'grey';
    let historicalColor = this.props.view == 'historical' ? 'white' : 'grey';

    let first = {
      text : `Matched Orders (${this.props.matchedOrders.length})`,
      action: this.changeView.bind(this,'complete'),
      color: 'white'
    }
    let second = {
      text : `Historical Orders (${this.props.pastOrders.length})`,
      action: this.changeView.bind(this,'historical')
    }
    if(this.props.view == 'historical'){
      let temp = second;
      second = first;
      first = temp;
    }

    // <span style={{cursor:'pointer',paddingLeft:'10px',color:'white',opacity:0.5,float:'right'}} onClick={second.action}>
    // {second.text}
    // </span>
    return (
      <div className='col s6' style={{paddingLeft:'0.375rem'}}>
        <h6 style={titleStyle} >
          <span style={{cursor:'pointer',paddingRight:'10px',color:'white'}} onClick={first.action}>
          {first.text}
          </span>
        </h6>

        <div className='col s12 section'>
          <TableHeader items={items} classes={classes}/>
          <div className="col s12" style={{height:'200px',overflowY:'scroll',}}>
            <table className="white-text striped" style={{tableLayout:"fixed",fontSize:"0.85em"}}>
              <tbody style={{lineHeight:'25px',padding:'0px'}}>
                {this.props.view === 'historical' && this.renderItems(take(20,this.props.pastOrders),true)}
                {this.props.view === 'complete' && this.renderItems(take(20,this.props.matchedOrders),false)}
              </tbody>
            </table>
            {this.props.view === 'complete' ? this.renderModal() : this.renderUnlock()}
          </div>
        </div>
      </div>
		)
  }
}

function mapStateToProps(state,props) {

  let matchedOrders = state.orderbook.my_matched_orders;
  let pastOrders = state.orderbook.my_past_orders;

  return {
    wallet: state.passport.wallet,
    fee: state.passport.fee,
    matchedOrders:matchedOrders,
    pastOrders:pastOrders
  };
}

export default connect(mapStateToProps, {
  getNEOFee,getBTCFee,getETHFee,getLSKFee,getWAVFee,getNRGFee,getEMBFee,getDAIFee,getUSDTFee,
  payNEO,payBTC,payETH,payLSK,payWAV,payNRG,payEMB,payDAI,payUSDT,
  unlockCollateral
})(MatchedOrders);
